import { graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import { InfoPageHero } from "../components/layout/info-hero";
import { Layout } from "../components/layout/layout";
import { LocationType } from "../interfaces";

function Faq({ location }: { location: LocationType }) {
    const data: {
        title: string;
        description: string;
        faqs: { answer: string; question: string }[];
    } = useStaticQuery(graphql`
        {
            content: articlesJson(key: { eq: "faq" }) {
                title
                description
                faqs {
                    question
                    answer
                }
            }
        }
    `).content;

    return (
        <Layout
            path="/faq/"
            title={data.title}
            faqs={data.faqs}
            description={data.description}
        >
            <InfoPageHero title={data.title} centered={true} />

            <div className="w-text-article m-auto px-2 pb-0 pt-12">
                {data.faqs.map((faq, index) => (
                    <div key={index}>
                        <h2 className="mb-6 text-2xl font-bold font-bold tracking-wide">
                            {faq.question}
                        </h2>
                        <p className="mb-12">
                            <div className="relative top-[-2px] mr-4 inline-block h-[16px] w-[16px]"></div>
                            {faq.answer}
                        </p>
                    </div>
                ))}
            </div>
        </Layout>
    );
}
export default Faq;
